// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"223":"54c37a3a","304":"39bb94e5","924":"5777fc7a"}[chunkId] + ".js";
};